<template>
  <path
    id="archiwum"
    d="M3.425,11.1425 L20.575,11.1425 L20.575,1.71 L3.425,1.71 L3.425,11.1425 Z M20.575,12.8575 L3.425,12.8575 L3.425,22.29 L20.575,22.29 L20.575,12.8575 Z M8.57,5.9975 L15.43,5.9975 C15.9035841,5.9975 16.2875,6.38141583 16.2875,6.855 C16.2875,7.32858417 15.9035841,7.7125 15.43,7.7125 L8.57,7.7125 C8.09641583,7.7125 7.7125,7.32858417 7.7125,6.855 C7.7125,6.38141583 8.09641583,5.9975 8.57,5.9975 Z M8.57,17.145 L15.43,17.145 C15.9035841,17.145 16.2875,17.5289159 16.2875,18.0025 C16.2875,18.4760841 15.9035841,18.86 15.43,18.86 L8.57,18.86 C8.09641583,18.86 7.7125,18.4760841 7.7125,18.0025 C7.7125,17.5289159 8.09641583,17.145 8.57,17.145 Z M2.5675,-0.005 L21.4325,-0.005 C21.9060841,-0.005 22.29,0.378915827 22.29,0.8525 L22.29,23.1475 C22.29,23.6210841 21.9060841,24.005 21.4325,24.005 L2.5675,24.005 C2.09391583,24.005 1.71,23.6210841 1.71,23.1475 L1.71,0.8525 C1.71,0.378915827 2.09391583,-0.005 2.5675,-0.005 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'ArchiveIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
